import { makeAutoObservable } from 'mobx';
import type { PopulatedSection } from 'root/types/menusTypes';
import type { TFunction } from '@wix/yoshi-flow-editor';
import type { AvailabilityStatusKeysConfig } from 'root/availabilityStatusKeys';
import type { TimeSlot, DispatchInfo } from 'root/types/businessTypes';
import type { CommonAvailability } from 'root/types/availability';
import type { SectionAvailability } from 'root/types/section';
import { AvailabilityState } from './AvailabilityState';
import type { AvailabilityStatus } from '@wix/ambassador-restaurants-menu-settings-v1-menu-ordering-settings/types';

export class SectionState {
  section: PopulatedSection;
  private availabilityState: AvailabilityState;

  constructor(section: PopulatedSection) {
    this.section = section;
    this.availabilityState = new AvailabilityState(
      section.orderSettings?.availability as CommonAvailability
    );
    makeAutoObservable(this);
  }

  get id() {
    return this.section.id;
  }

  get isAvailable() {
    return this.availabilityState.isAvailable;
  }

  get availability(): CommonAvailability | undefined {
    return this.availabilityState.currentAvailability;
  }

  get hasNextAvailableTimeslot() {
    return this.availabilityState.hasNextAvailableTimeslot;
  }

  updateSectionAvailability(sectionAvailability: SectionAvailability) {
    this.availabilityState.updateAvailability(sectionAvailability as CommonAvailability);
  }

  updateAvailabilityStatus(availabilityStatus: AvailabilityStatus) {
    this.availabilityState.updateAvailabilityStatus(availabilityStatus);
  }

  initializeAvailability(
    selectedTimeSlot?: TimeSlot,
    timezone?: string,
    businessDaysAhead?: number
  ) {
    this.availabilityState.initializeAvailability(selectedTimeSlot, timezone, businessDaysAhead);
  }

  updateAvailabilityForDispatch(dispatchInfo: DispatchInfo) {
    this.availabilityState.updateAvailabilityForDispatch(dispatchInfo);
  }

  getAvailabilityStatus({
    locale,
    timezone,
    t,
    keys,
  }: {
    locale: string;
    timezone: string;
    t: TFunction;
    keys: AvailabilityStatusKeysConfig;
  }) {
    return this.availabilityState.getAvailabilityStatus({
      locale,
      timezone,
      t,
      keys,
    });
  }
}
